var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopBorderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 3L11.998 10C11.998 11.1046 11.1026 12 9.99805 12L2.00025 12C0.895677 12 0.000246647 11.1046 0.000246696 10L0.000247002 3L2.0744 3L2.0744 9C2.0744 9.55228 2.52212 10 3.0744 10L9.11588 10C9.66816 10 10.1159 9.55228 10.1159 9L10.1159 3L11.998 3Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 -8.74228e-08C11.1046 -3.91405e-08 12 0.895431 12 2L-8.74228e-08 2C-3.91405e-08 0.89543 0.895431 -4.85396e-07 2 -4.37114e-07L10 -8.74228e-08Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBorderIcon);
export default __webpack_public_path__ + "static/media/top-border-icon.17d97afebda0e0e321af03bd08ee4ef5.svg";
export { ForwardRef as ReactComponent };